import React from 'react';

export default function Nav() {
  return (
    <div className="nav">
      <a className="px-4 py-2 bg-red-400 rounded" href="/">
        Back Home
      </a>
    </div>
  );
}
